import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Rating,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import FooterNav from "./FooterNav";
import axios from "axios";

const CardDetail = () => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);
  const [showRating, setShowRating] = useState(false);
  const [rating, setRating] = useState(null);
  const [data, setData] = useState();
  const videoRef = useRef(null);
  const { id } = useParams();


  const getUserData = async (ids) => {
    try {
      const response = await axios.get(
        `https://taskapi.demovt360.xyz/sst/src/api/get_tasks_single.php?userid=${ids}&taskid=${id}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        setData(response.data.task); // Uncomment to set data if needed
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // https://videoratingst.online/sst/src/api/complete_task.php


  const handleSubmit = async (event) => {
    event.preventDefault();

    // Create FormData object
    const formData = new FormData();
    formData.append("tasknewid", data.id);
    try {
      const response = await axios
        .post("https://taskapi.demovt360.xyz/sst/src/api/complete_task.php", formData)

        .then((res) => {
          console.log("dddd", res);
          if (res.status === 200 && res.data.status === 'success') {
          // alert(res.data.message);
          // setTimeout(() => {
            navigate("/task");
          // }, 500);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
      // history("/home");
    }
  };




  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
    }
  }, []);

  const handlePlayVideo = () => {
    setShowVideo(true);
    setShowRating(false);
    setTimeout(() => {
      videoRef.current.play(); // Auto play video
    }, 500);
  };
  const handleClick = (item) => {
    // console.log('dddddddddd',item)
    navigate(`/detail/${item}`);
  };
  // When video completes, show rating
  const handleVideoEnd = () => {
    setShowRating(true);
  };
  return (
    <>
      <div style={{ width: "100%", marginBottom: "30px" }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f83600",
            marginBottom: 1,
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Details
          </Typography>
          <Box> </Box>
        </Box>

        <Grid
          item
          sx={{
            height: { xs: 200 },
            marginBottom: 8,
            margin: "0 10px 10px 10px",
          }}
        >
          <div style={{ textAlign: "center", marginTop: "15px" }}>
            {!showVideo && (
              <Card
                sx={{
                  maxWidth: 600,
                  height: 200,
                  marginTop: "20px",
                  position: "relative",
                  borderRadius: "12px",
                  boxShadow: 1,
                  overflow: "hidden",
                  backgroundColor: "rgb(71, 71, 71)",
                }}
              >
                <IconButton
                  onClick={handlePlayVideo}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "rgb(71, 71, 71)",
                    padding: "20px",
                    borderRadius: "50%",
                    transition: "0.3s",
                    "&:hover": {
                      backgroundColor: "rgb(71, 71, 71)",
                    },
                  }}
                >
                  <PlayCircleOutlineIcon
                    sx={{ fontSize: 60, color: "#1976d2" }}
                  />
                </IconButton>
              </Card>
            )}

            {showVideo && (
              <Card
                sx={{
                  maxWidth: 600,
                  height: 205,
                  borderRadius: "12px",
                  boxShadow: 1,
                  marginTop: "20px",
                  backgroundColor: "rgb(71, 71, 71)",
                }}
              >
                <CardContent>
                  <video
                    ref={videoRef}
                    width="100%"
                    height="180px"
                    controls
                    onEnded={handleVideoEnd}
                    style={{ borderRadius: "10px" }}
                  >
                    <source
                      src={`https://taskapi.demovt360.xyz/${data?.video_path}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </CardContent>
              </Card>
            )}
          </div>
        </Grid>
        {showRating && (
          <div
            style={{
              display: "flex",
              padding: "10px",
              margin: "21px 10px 0 10px",
              // height: {  xs: 50 },
              marginTop: "5px",
            }}
          >
            <Typography variant="h6" color="#333">
              Rate this video:
            </Typography>
            <Rating
              name="video-rating"
              value={rating}
              onChange={(event, newValue) => setRating(newValue)}
              size="large"
            />
            {/* {rating && (
                  <Typography>You rated this video {rating} stars!</Typography>
                )} */}
          </div>
        )}

        <Box style={{ padding: "0 20px" }}>
          <Typography color="#333">{data?.task_name}</Typography>
          <Typography color="#333">
            Description: {data?.video_description}
          </Typography>
        </Box>
        <Typography color="#333" pl={2}>
          Related recommendations
        </Typography>

        {rating !== null ? (
          <Box
            sx={{
              display:"flex",
              justifyContent:"center",
              // background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
              alignItems: "center",
              // width: "50%",
              // height: "100%",
            }}
          >
            {" "}
            <Button
            onClick={handleSubmit}
              sx={{
                px: 4,
                // py: 1,
                // mb: 1,
                background: "#f83600",
                color: "#fff",
                borderRadius: "20px",
                fontSize: "18px",
                fontWeight: "bold",
                lineHeight: 1,
                textTransform: "none",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  background:
                    "linear-gradient(to right, rgb(74, 64, 44), rgb(62, 81, 81))",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        ) : (
          ""
        )}

        {/* <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "13px",
            minWidth: "165px",
            marginTop: "20px",
          }}
        >

          {data.map((item, ind) => {
            return (
              <div
                key={ind}
                onClick={() => handleClick(item.task_name)}
                style={{
                  display: "flex",
                  // flexDirection: "column",
                  position: "relative",
                  width: '100%',
                  margin: '0 10px',
                  // minWidth: "165px",
                  alignItems:'center',
                  background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                  borderRadius: "8px",
                  fontSize: "12px",
                  color: "#333",
                  overflow: "hidden",
                  boxShadow:
                    "4px 4px 10px rgb(227 196 196 / 8%), -4px -4px 10px rgb(97 33 33 / 60%)",
                  transition: "all 0.3s ease-in-out",
                  border: "1px solid rgba(0, 0, 0, 0.05)",
                }}
              >

                
                <img
                  src="/images/newd.jpg"
                  draggable="false"
                  width={'50%'}
                  height={"120px"}
                />

                <Box
                  sx={{
                    // background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                    textAlign: "center",
                    width: '50%',
                    height:'100%',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#828282", fontWeight: "bold" }}
                  >
                    {item.task_name}
                  </Typography>
                  <Typography sx={{ color: "#666", mb: 1, fontSize: "16px" }}>
                    Commission: <strong>12.00</strong>
                  </Typography>
                  <Button
                    sx={{
                      px: 2,
                      // py: 1,
                      mb: 1,
                      background: "#f83600",
                      color: "#fff",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      lineHeight: 1,
                      textTransform: "none",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        background: "linear-gradient(to right, rgb(74, 64, 44), rgb(62, 81, 81))",
                      },
                    }}
                  >
                    Rating Now
                  </Button>
                </Box>
              </div>
            );
          })}
      
        </div> */}
      </div>
      {/* <Box style={{ marginTop: "70px" , background:"red"}}> */}
      <FooterNav />
      {/* </Box> */}
    </>
  );
};
export default CardDetail;
